import api from '@/api'
import _ from 'lodash'

export default {
  state: {
    settings: [],

    globalSettings: {
      address: undefined,
      title: undefined
    }
  },

  getters: {
    settings: s => s.settings,
    setting: s => name => null,

    companyAddress: s => s.globalSettings.address,
    companyTitle: s => s.globalSettings.title
  },

  mutations: {
    setSettings(s, data) {
      s.settings = data;
    },

    setGlobalSettings(s, data) {
      s.globalSettings.address = data.address;
      s.globalSettings.title = data.name;
    }
  },

  actions: {
    async fetchGlobalSettings({commit}) {
      let error;

      try {
        const response = await api.get('/parameters/data');
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          commit('setGlobalSettings', result);
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch (e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async fetchSettings({commit, getters}) {
      let error;

      try {
        const response = await api.get('/parameters');
        const { status, result, errorCode } = response.data;
        
        if (status === 200) {
          commit('setSettings', result);
          return getters.settings;
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async updateSettings({dispatch}, {id, value}) {
      let error;

      try {
        const response = await api.put(`/parameters`, { changes: [{id, value}] });
        const { status, errorCode } = response.data;

        if (status === 200) {
          return await dispatch('fetchSettings');
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    }
  }
}
